import type { ReactNode } from 'react';

/**
 * Мелкие знаки состояния кита: чип давности, точка пункта чек-листа,
 * легенда точек, шкала заполненности.
 */

/** Чип давности `.age` (AgeChip): спокойный, жёлтый с порога −2, красный с порога */
export function AgeChip({ days, limit, children }: { days: number; limit: number; children: ReactNode }) {
  const tone = days >= limit ? ' bad' : days >= limit - 2 ? ' hot' : '';
  return <span className={`age${tone}`}>{children}</span>;
}

export type DotState = 'ok' | 'wait' | 'none' | 'na';

/** Точка пункта чек-листа в таблице `.dt` */
export function StatusDot({ state, title }: { state: DotState; title?: string }) {
  return <span className={`dt ${state}`} title={title} />;
}

/** Легенда точек `.legend` (кит) — под таблицей с точками */
export function Legend({ items }: { items: { state: DotState; label: string }[] }) {
  return (
    <div className="legend lgd">
      {items.map((i) => (
        <span key={i.state}>
          <StatusDot state={i.state} />
          {i.label}
        </span>
      ))}
    </div>
  );
}

export const CHECKLIST_LEGEND: { state: DotState; label: string }[] = [
  { state: 'ok', label: 'выполнено' },
  { state: 'wait', label: 'требует действия' },
  { state: 'none', label: 'не начато' },
  { state: 'na', label: 'не требуется' },
];

/** Шкала `.bar-mini` (ProgressBar): доля 0…1; `full` — заполнено до предела, жёлтым */
export function ProgressBar({ value, full }: { value: number; full?: boolean }) {
  const pct = Math.max(0, Math.min(100, Math.round(value * 100)));
  return (
    <span className={full ? 'bar-mini full' : 'bar-mini'}>
      <i style={{ width: `${pct}%` }} />
    </span>
  );
}
